import { Component, ViewEncapsulation, Input, EventEmitter } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  Validators
} from '@angular/forms';

import { TdIssuesService } from './td-issues.service';
import { TdIssuesModel } from './td-issues.model';

declare var jQuery:any;
declare var Materialize:any;

@Component({
  selector: 'td-issues',
  templateUrl: './td-issues.component.html',
  styleUrls: ['./td-issues.component.scss'],
  providers: [],
  encapsulation: ViewEncapsulation.None,
  outputs: []
})
export class TdIssuesComponent {
  itemForm:FormGroup;
  @Input() issue:TdIssuesModel;
  currentUser:any;
  pluginId:string;
  imageRandom:any;
  messageApi:any;
  sendMessage:boolean;
  showForm:boolean;

  constructor(private issuesService:TdIssuesService, formBuilder:FormBuilder) {
    this.issue = new TdIssuesModel(null);
    this.sendMessage = false;
    this.imageRandom = 'https://dl.dropboxusercontent.com/u/101447754/liontude/funny.webp';

    this.issuesService.currentIssue.subscribe(
      (value:any) => {
        if (value.isError) {
          this.showForm = true;

          this.issue.errorMessage = value.newIssue;
          this.issue.subject = 'Message to Liontude from WP-Record Plugin';
          this.issue.name = this.currentUser.firstname + ' ' + this.currentUser.user_lastname;
          this.issue.message = '';
          this.issue.emailFrom = this.currentUser.user_email;
          this.issue.extraData = {};

          jQuery('#modal-td-issues').modal('open');
        }
      });

    this.itemForm = formBuilder.group({
      'errorMessage': [Validators.required],
      'subject': [Validators.required],
      'name': [Validators.required],
      'message': [Validators.required],
      'emailFrom': [Validators.required],
      'extraData': [Validators.required],
    });

    this.issuesService
      .getCurrentUser()
      .subscribe(data => {
          this.currentUser = data.user;
          this.pluginId = data.plugin_id
        },
        err => {
          Materialize.toast(`<p>${err.message}</p>`, 10000);
          console.error(err);
        },
        () => console.log('done')
      );
  }

  onSubmit(value:TdIssuesModel):void {
    this.sendMessage = true;
    value.errorMessage = this.issue.errorMessage;
    value.extraData = {
      pluginId: this.pluginId,
      pluginName: 'WP Record',
      slugName: 'wp-record',
      version: '0.1.0',
      url: jQuery('#wp-admin-bar-view a').attr('href')
    };

    //this.issuesService
    //  .postSendIssue(value)
    //  .subscribe((data:any) => {
    //      if (data) {
    //        this.showForm = false;
    //        this.sendMessage = false;
    //        this.messageApi = data.data;
    //        this.imageRandom = this.messageApi.funnyImage;
    //        //jQuery('#modal-td-issues').modal('close');
    //      }
    //    },
    //    err => {
    //      Materialize.toast(`<p>${err}</p>`, 10000);
    //      setTimeout(() => {
    //        jQuery('#modal-td-issues').modal('close');
    //      }, 3000)
    //    },
    //    () => console.log('done')
    //  );

    this.issuesService
      .postSendIssueByEmail(value)
      .subscribe((data:any) => {
          if (data) {
            this.showForm = false;
            this.sendMessage = false;
            this.messageApi = data.data;
            //this.imageRandom = this.messageApi.funnyImage;
          }
        },
        err => {
          Materialize.toast(`<p>${err}</p>`, 10000);
          setTimeout(() => {
            jQuery('#modal-td-issues').modal('close');
          }, 3000)
        },
        () => console.log('done')
      );
  }

  closeModal() {
    jQuery('#modal-td-issues').modal('close');
  }

  ngOnInit() {
    // Modal Initialization.
    jQuery('.modal').modal({
      dismissible: true
    });
  }
}


// WEBPACK FOOTER //
// ./admin/src/app/components/td-issues/td-issues.component.ts